import { Button, Dialog, DialogPanel, DialogTitle } from '@headlessui/react'
import { useState } from 'react'
import { disclaimerData } from './disclaimerData'



export default function Disclaimer() {
  let [isOpen, setIsOpen] = useState(true)

  function open() {
    setIsOpen(true)
  }

  function close() {
    setIsOpen(false)
  }
  function empty() {
  }



  return (
    <>
      <Button
        onClick={open}
        className="rounded-md place-content-center bg-orange-500/20 py-2 px-4 text-xs font-medium text-white focus:outline-none data-[hover]:bg-black/30 data-[focus]:outline-1 data-[focus]:outline-white"
      >
    ⚠️    Disclaimer ! ⚠️
      </Button>

      <Dialog open={isOpen} as="div" className="relative z-10 focus:outline-none  " onClose={empty}>
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto  bg-black/10 backdrop-blur">
          <div className="flex min-h-full items-center justify-center p-4">
            <DialogPanel
              transition
              className="w-full   max-w-3xl rounded-xl bg-white/15 p-6 backdrop-blur-2xl duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0"
            >
              <DialogTitle as="h3" className=" text-red-500 font-bold text-2xl text-center">
                ⚠️  Important Notice ! ⚠️
              </DialogTitle>



              <div className="mt-2 text-sm/6 text-white/50 text-center">
                <h1 className='text-blue-400 font-bold text-sm'>Before start Trading</h1>
              </div>
              <p className="mt-2 text-sm/6 text-green-500 font-bold">
                By using Phoenix Bot and its services, you acknowledge and agree to the following terms and conditions:
              </p>

              <div className='overflow-hidden   border-[3px] border-black my-5 rounded-2xl'>
              <div className='h-[50vh] max-h-4xl overflow-y-scroll bg-black/50 overflow-x-hidden p-5 rounded-lg '>



                {
                  disclaimerData.map((warning,idx) => {

                    if (warning.sub) {
                      return (
                        <div key={idx} className='grid gap-2'>
                          <p className="mt-2 text-sm text-red-500 font-bold">{warning.title}</p>
                          {warning.sub.map((sub) => (<div key={sub.title}>
                            <p className="mt-2 text-sm/6  font-bold text-orange-500">{sub.title} : <span className="mt-2 text-sm/6 text-neutral-200 font-light ">{sub.desc}</span>
                            </p>
                          </div>))
                          }
                        </div>
                      )

                    } else {
                      return (<div key={warning.title} className='grid gap-2'>
                        <p className="mt-2 text-sm text-red-500 font-bold">{warning.title}</p>
                        <p className="mt-2 text-sm/6 text-neutral-200 ">{warning.desc}</p>

                      </div>)
                    }
                  })
                }

              </div>
              </div>
              <div className="mt-4">
                <Button
                  className="inline-flex items-center gap-2 rounded-md bg-orange-500 py-1.5 px-3 text-sm/6 font-semibold text-white shadow-inner shadow-white/10 focus:outline-none data-[hover]:bg-gray-600 data-[focus]:outline-1 data-[focus]:outline-white data-[open]:bg-gray-700"
                  onClick={close}
                >
                  i Agree and i'm Aware
                </Button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  )
}